/* KIT · widgets de conversión: comprados juntos, guía de tallas, popup de correo (+ intención de salida),
   ampliar páginas (digital), extras del carrito (barra de meta + recomendados). Sin dependencias. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function fmt(c, f) {
    f = f || '${{amount}}';
    var n = (c / 100).toFixed(2).split('.'), a = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*\w+\s*\}\}/, a + (n[1] !== '00' ? '.' + n[1] : ''));
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  /* Agrega varias variantes y refresca el cajón del carrito de Dawn si existe */
  function addItems(items) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && drawer.getSectionsToRender) body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    return fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        if (drawer && j.sections && drawer.renderContents) { j.id = items[0].id; drawer.renderContents(j); if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty'); }
        else { var b = document.getElementById('cart-icon-bubble'); if (!drawer) document.dispatchEvent(new CustomEvent('kit:cart-added', { detail: j })); if (!drawer && !document.querySelector('cart-notification')) location.href = (window.routes && window.routes.cart_url) || '/cart'; }
        return j;
      });
  }
  /* respaldo si Shopify aún no tiene recomendaciones (tienda nueva): productos de una colección */
  function fallback(handle) {
    return fetch('/collections/' + (handle || 'all') + '/products.json?limit=12').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) {
      return { products: (j.products || []).map(function (p) {
        return { id: p.id, title: p.title, url: '/products/' + p.handle, available: p.variants.some(function (v) { return v.available; }), featured_image: p.images[0] && p.images[0].src,
          variants: p.variants.map(function (v) { return { id: v.id, available: v.available, price: Math.round(parseFloat(v.price) * 100), compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : null }; }) };
      }) };
    });
  }
  window.KitWidgets = { addItems: addItems };

  /* ---------- Comprados juntos ---------- */
  function Fbt(root) {
    var list = $('[data-kw-fbt-list]', root), money = root.dataset.money, msg = $('[data-kw-fbt-msg]', root);
    function sum() {
      var t = 0, c = 0, n = 0;
      $$('input[type=checkbox]', list).forEach(function (i) { if (i.checked) { t += +i.dataset.price; c += +i.dataset.cmp; n++; } });
      $('[data-kw-fbt-total]', root).textContent = fmt(t, money);
      var ce = $('[data-kw-fbt-cmp]', root); if (c > t) { ce.textContent = fmt(c, money); ce.hidden = false; } else ce.hidden = true;
      return n;
    }
    function item(p) {
      var v = p.variants.filter(function (x) { return x.available; })[0]; if (!v) return '';
      var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="' + esc(p.title) + '" width="120" height="120" loading="lazy">' : '';
      var cmp = v.compare_at_price && v.compare_at_price > v.price ? ' <s>' + fmt(v.compare_at_price, money) + '</s>' : '';
      return '<li class="kw-fbt__item"><label><input type="checkbox" checked data-id="' + v.id + '" data-price="' + v.price + '" data-cmp="' + (v.compare_at_price > v.price ? v.compare_at_price : v.price) + '"><span class="kw-fbt__img">' + img + '</span><span class="kw-fbt__info"><a class="kw-fbt__name" href="' + p.url + '">' + esc(p.title) + '</a><span class="kw-fbt__price">' + fmt(v.price, money) + cmp + '</span></span></label></li>';
    }
    function load(intent) {
      return fetch(root.dataset.url + '.json?product_id=' + root.dataset.pid + '&limit=' + (+root.dataset.max + 1) + '&intent=' + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; });
    }
    function finish() { var n = $$('.kw-fbt__item', list).length; if (n < 2 && root.dataset.emptyHide === 'true') root.hidden = true; sum(); }
    if (root.dataset.auto === 'true') {
      load(root.dataset.intent).then(function (j) { return (j.products || []).length ? j : load('related'); })
        .then(function (j) { return (j.products || []).length ? j : fallback(root.dataset.fallback); }).then(function (j) {
        var html = (j.products || []).filter(function (p) { return String(p.id) !== root.dataset.pid && p.available; }).slice(0, +root.dataset.max).map(item).join('');
        list.insertAdjacentHTML('beforeend', html); finish();
      }).catch(finish);
    } else finish();
    list.addEventListener('change', sum);
    var btn = $('[data-kw-fbt-add]', root);
    btn.addEventListener('click', function () {
      var items = $$('input[type=checkbox]', list).filter(function (i) { return i.checked; }).map(function (i) { return { id: +i.dataset.id, quantity: 1 }; });
      btn.disabled = true; msg.textContent = '';
      addItems(items).then(function () { msg.textContent = root.dataset.added; }).catch(function (e) { msg.textContent = (e && (e.description || e.message)) || 'Error'; }).then(function () { btn.disabled = false; });
    });
  }

  /* ---------- Diálogos genéricos ---------- */
  function openDlg(d) { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); document.documentElement.classList.add('kw-lock'); }
  function closeDlg(d) { if (d.close) d.close(); else d.removeAttribute('open'); document.documentElement.classList.remove('kw-lock'); }
  document.addEventListener('click', function (e) {
    var x = e.target.closest('[data-kw-close]'); if (x) { var d = x.closest('dialog'); if (d) closeDlg(d); }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('kw-dlg')) closeDlg(e.target);
  });
  document.addEventListener('close', function (e) { if (e.target.classList && e.target.classList.contains('kw-dlg')) document.documentElement.classList.remove('kw-lock'); }, true);

  /* ---------- Guía de tallas ---------- */
  function SizeGuide(root) {
    var link = $('[data-kw-sg-open]', root), dlg = $('[data-kw-sg-dlg]', root);
    document.body.appendChild(dlg);
    var sel = (root.dataset.anchor || '').split(',');
    for (var i = 0; i < sel.length; i++) { var a = sel[i].trim() && document.querySelector('.product__info-container ' + sel[i].trim()); if (a) { a.insertAdjacentElement('afterend', link); link.classList.add('is-moved'); break; } }
    link.addEventListener('click', function () { openDlg(dlg); });
  }

  /* ---------- Ampliar (producto digital) ---------- */
  function Zoom(root) {
    var dlg = $('[data-kw-zoomdlg]', root); if (!dlg) return;
    var img = $('[data-kw-zoomimg]', dlg);
    $$('[data-kw-zoom]', root).forEach(function (b) { b.addEventListener('click', function () { img.src = b.dataset.kwZoom; openDlg(dlg); }); });
  }

  /* ---------- Popup de correo + intención de salida ---------- */
  function Popup(root) {
    var KEY = 'kitPopup:' + root.id, days = +root.dataset.days || 7, shown = false;
    var preview = /[?&]kit_popup=1/.test(location.search), posted = !!$('[data-kw-pop-done]', root);
    var page = root.dataset.pages, path = location.pathname;
    function show() {
      if (shown) return; shown = true; root.hidden = false; document.documentElement.classList.add('kw-lock');
      var f = $('input[type=email],button', root); if (f) setTimeout(function () { f.focus(); }, 50);
    }
    function hide() { root.hidden = true; document.documentElement.classList.remove('kw-lock'); try { localStorage.setItem(KEY, Date.now() + days * 864e5); } catch (e) {} }
    $$('[data-kw-close]', root).forEach(function (b) { b.addEventListener('click', hide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) hide(); });
    var cp = $('[data-kw-copy]', root); if (cp) cp.addEventListener('click', function () { try { navigator.clipboard.writeText(cp.dataset.kwCopy); cp.classList.add('is-copied'); } catch (e) {} });
    if (posted) { show(); try { localStorage.setItem(KEY, Date.now() + 365 * 864e5); } catch (e) {} return; }
    if (preview) { show(); return; }
    if (root.dataset.enabled !== 'true') return;
    if (page === 'product' && path.indexOf('/products/') < 0) return;
    if (page === 'home' && path !== '/' && !/^\/[a-z]{2}(-[a-z]{2})?\/?$/i.test(path)) return;
    try { if (+localStorage.getItem(KEY) > Date.now()) return; } catch (e) {}
    var d = +root.dataset.delay; if (d > 0) setTimeout(show, d * 1000);
    var sc = +root.dataset.scroll;
    if (sc > 0) window.addEventListener('scroll', function f() { var h = document.documentElement; if ((h.scrollTop + innerHeight) / h.scrollHeight * 100 >= sc) { window.removeEventListener('scroll', f); show(); } }, { passive: true });
    if (root.dataset.exit === 'true') {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) show(); });
      var maxY = 0, lastY = 0, lastT = 0;
      window.addEventListener('scroll', function () {
        var y = scrollY, t = Date.now();
        if (y > maxY) maxY = y;
        if (matchMedia('(pointer:coarse)').matches && maxY > innerHeight * 1.5 && lastY - y > 120 && t - lastT < 250) show();
        lastY = y; lastT = t;
      }, { passive: true });
    }
  }

  /* ---------- Extras del carrito: recomendados ---------- */
  function CartUpsell(root) {
    if (root.dataset.kwReady) return; root.dataset.kwReady = '1';
    var pid = root.dataset.pid, list = $('[data-kw-up-list]', root), money = root.dataset.money;
    var inCart = (root.dataset.incart || '').split(',');
    if (!pid || !list || list.children.length) { bindUp(root); return; }
    fetch(root.dataset.url + '.json?product_id=' + pid + '&limit=6&intent=' + root.dataset.intent).then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j.products || []).length || root.dataset.intent === 'related' ? j : fetch(root.dataset.url + '.json?product_id=' + pid + '&limit=6&intent=related').then(function (r) { return r.json(); }); })
      .then(function (j) { return (j.products || []).length ? j : fallback(root.dataset.fallback); })
      .then(function (j) {
        var ps = (j.products || []).filter(function (p) { return p.available && inCart.indexOf(String(p.id)) < 0; }).slice(0, +root.dataset.max);
        if (!ps.length) { root.hidden = true; return; }
        list.innerHTML = ps.map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0];
          var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="64" height="64" loading="lazy">' : '';
          return '<li class="kw-up__item">' + img + '<span class="kw-up__info"><a href="' + p.url + '">' + esc(p.title) + '</a><span>' + fmt(v.price, money) + (v.compare_at_price > v.price ? ' <s>' + fmt(v.compare_at_price, money) + '</s>' : '') + '</span></span><button type="button" class="kw-up__btn" data-kw-up-add="' + v.id + '">' + esc(root.dataset.btn) + '</button></li>';
        }).join('');
        root.hidden = false; bindUp(root);
      }).catch(function () { root.hidden = true; });
  }
  function bindUp(root) {
    $$('[data-kw-up-add]', root).forEach(function (b) { b.addEventListener('click', function () { b.disabled = true; addItems([{ id: +b.dataset.kwUpAdd, quantity: 1 }]).catch(function () { b.disabled = false; }); }); });
  }

  function init(scope) {
    $$('[data-kw-fbt]', scope).forEach(function (r) { if (!r.dataset.kwReady) { r.dataset.kwReady = 1; Fbt(r); } });
    $$('[data-kw-sg]', scope).forEach(function (r) { if (!r.dataset.kwReady) { r.dataset.kwReady = 1; SizeGuide(r); } });
    $$('.kw-dg', scope).forEach(function (r) { if (!r.dataset.kwReady) { r.dataset.kwReady = 1; Zoom(r); } });
    $$('[data-kw-pop]', scope).forEach(function (r) { if (!r.dataset.kwReady) { r.dataset.kwReady = 1; Popup(r); } });
    $$('[data-kw-up]', scope).forEach(CartUpsell);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* el cajón de Dawn reemplaza su HTML al cambiar el carrito: re-inicializa los recomendados */
  var cd = document.querySelector('cart-drawer'); if (cd) new MutationObserver(function () { $$('[data-kw-up]:not([data-kw-ready])', cd).forEach(CartUpsell); }).observe(cd, { childList: true, subtree: true });
})();
